import { addQueryArgs } from '@wordpress/url';
import 'nouislider';
import { getParamOfUrl } from './search';
import { toggle } from 'slidetoggle';

let query = { offset: 1, orderby: 'date', order: 'DESC', template: 'archive_page' };
let minPriceNode, maxPriceNode, priceSliderNode, minPrice, maxPrice;
let searchNode, searchPriceNode;
const priceInit = () => {
	minPriceNode = document.getElementById( 'realpress-search-input-min-price' );
	maxPriceNode = document.getElementById( 'realpress-search-input-max-price' );
	priceSliderNode = document.getElementById( 'realpress-search-price' );
	minPrice = REALPRESS_GLOBAL_OBJECT.advanced_search.min_price || '';
	maxPrice = REALPRESS_GLOBAL_OBJECT.advanced_search.max_price || '';
};

const realpressAdvancedSearch = () => {
	searchNode = document.querySelector( '.realpress-advanced-search' );

	if ( ! searchNode ) {
		return;
	}
	searchPriceNode = searchNode.querySelector( '.realpress-range-slider' );
	toggleFields();
	handlePrice();
	search();
};

const handlePrice = () => {
	if ( ! searchPriceNode ) {
		return;
	}
	priceInit();

	if ( minPrice === '' || maxPrice === '' ) {
		return;
	}

	let start = minPrice;
	let end = maxPrice;
	if ( getParamOfUrl( 'min-price' ) ) {
		start = getParamOfUrl( 'min-price' );
	}

	if ( getParamOfUrl( 'max-price' ) ) {
		end = getParamOfUrl( 'max-price' );
	}
	noUiSlider.create( priceSliderNode, {
		start: [ parseInt( start ), parseInt( end ) ],
		connect: true,
		step: 1,
		tooltips: true,
		range: {
			min: parseInt( minPrice ),
			max: parseInt( maxPrice ),
		},
	} );

	priceSliderNode.noUiSlider.on( 'update', function( values, handle, unencoded ) {
		minPriceNode.value = values[ 0 ];
		maxPriceNode.value = values[ 1 ];
	} );
};

const toggleFields = () => {
	const toggleButtonNode = searchNode.querySelector( 'button.realpress-search-toggle-fields-button' );
	if ( ! toggleButtonNode ) {
		return;
	}

	toggleButtonNode.addEventListener( 'click', function( event ) {
		const toggleFieldsNode = searchNode.querySelector( '.realpress-search-toggle-fields' );
		toggle( toggleFieldsNode, {
			miliseconds: 300,
			elementDisplayStyle: 'flex',
		} );
	} );
};

const search = () => {
	if ( ! REALPRESS_GLOBAL_OBJECT.advanced_search.allow_redirect_page ) {
		return;
	}

	const searchWithMapNode = document.querySelector( '#realpress-search-with-map' );

	if ( searchWithMapNode ) {
		return;
	}

	let redirectUrl = REALPRESS_GLOBAL_OBJECT.advanced_search.redirect_page || '';

	if ( redirectUrl === 'archive_page' ) {
		redirectUrl = REALPRESS_GLOBAL_OBJECT.archive_property_page_url;
	} else {
		const template = 'search_with_map';
		query = { ...query, template };
	}

	const searchButtonNode = searchNode.querySelector( 'button.realpress-search-property-button' );
	searchButtonNode.addEventListener( 'click', function() {
		const fieldNodes = searchNode.querySelectorAll( '.realpress-search-field input,select' );
		if ( ! fieldNodes ) {
			return;
		}

		for ( let i = 0; i < fieldNodes.length; i++ ) {
			const fieldNode = fieldNodes[ i ];
			const name = fieldNode.getAttribute( 'name' );
			if ( fieldNode.value === '' ) {
				if ( query.hasOwnProperty( name ) ) {
					delete query[ name ];
				}
			} else {
				query[ name ] = fieldNode.value;
			}
		}

		document.location.href = addQueryArgs( redirectUrl, query );
	} );
};

export default realpressAdvancedSearch;
